var map = {
	"./ALT.png": "nqcq",
	"./ART.jpg": "RKC3",
	"./BIO.png": "fU2P",
	"./CAS.png": "mrWx",
	"./CAT.png": "ZGHS",
	"./DIG.png": "iGH5",
	"./FIQ.png": "jYhb",
	"./FIS2.png": "n/Iz",
	"./LIN.jpg": "gmgs",
	"./MAT2.jpg": "K/93",
	"./MCT.png": "HVBb",
	"./MNT.jpg": "J1aE",
	"./MUS.png": "UTiA",
	"./PRO.png": "MvUI",
	"./THE.png": "pTTI",
	"./educov-logo.png": "O/Hp",
	"./educov-white-logo.png": "8/XU",
	"./educov.jpg": "ERZ+"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g2Y0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*$
// module id = g2Y0
// module chunks = 1